import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/theme/ThemeProvider";

/**
 * Floating theme toggle. Placed in the top-right corner of the app so it's
 * reachable from any page without cluttering existing headers. Persists via
 * ThemeProvider's localStorage layer.
 *
 * Uses `position: fixed` with high z-index so it sits above modals + sheets.
 */
export default function ThemeToggle({ compact = false }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? "Switch to dark theme" : "Switch to light theme"}
      data-testid="theme-toggle"
      className={`fixed z-40 flex items-center gap-1.5 border transition-colors ${
        compact ? "px-2 py-1.5" : "px-3 py-2"
      } uppercase tracking-widest font-bold text-[10px] ${
        isLight
          ? "bottom-4 right-4 border-[rgba(15,23,42,0.2)] bg-white text-[#0F172A] hover:bg-[#F1F3F6]"
          : "bottom-4 right-4 border-white/20 bg-black text-white hover:bg-white/5"
      }`}
      style={{ backdropFilter: "blur(8px)" }}
    >
      {isLight ? <Moon size={12} /> : <Sun size={12} />}
      {!compact && (isLight ? "Dark" : "Light")}
    </button>
  );
}
